'use strict';
import React from 'react';
require('styles/BusinessBrief.scss');

class BusinessBriefComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  render(){
    let { article, business, isAuthor} = this.props
    let { desc } = article
    let { small_avatar, name, summary} = business
    let createMarkup = () =>  {
      return {__html: desc||(isAuthor?"快去完善专辑介绍吧～～":"如果我们无法探索宇宙，一定要把这颗星球看一看.")};
    }
    let now = new Date()
    let date = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}`
  	return (
  	  <div className="Business-Brief">
        {article.name?(
          <div className="article">
            <div className="title">
              {article.name}
            </div>
            <div className="author mt-10">
              <span>{date}</span>
              <span className="ml-10"><a href={business._id?`/business/${business._id}`:`/agent/${business.agent_id}`} style={{color:'#607fa6'}}>{name}</a></span>
            </div>
            <div className="cover mt-30">
              <img className="" src={article.cover} />
            </div>
            <div className="desc">
              <pre className="content-intro" dangerouslySetInnerHTML={createMarkup()} />
            </div>
		  	</div>
        ):null}
        {name?(
          <div className={`business mt-50 ${article.name?'border':''}`}>
            <div className="avatar">
              <img src={small_avatar} />
            </div>
            <div className="name">
              {name}
            </div>
            <div className="intro">
              {summary}
            </div>
          </div>
        ):null}
  	  </div>
  	);
  }
}

BusinessBriefComponent.displayName = 'BusinessBriefComponent';

export default BusinessBriefComponent;



// WEBPACK FOOTER //
// ./src/components/BusinessBriefComponent.js